import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export const downloadPDF = async (type, eventName, printOptions) => {
  const pages = document.querySelectorAll(`.${type}Page`)
  const pdf = new jsPDF({ orientation: printOptions?.orientation || 'p', unit: 'mm', format: 'a4', compress: true })
  const suffix = printOptions?.doubleSided ? 'FrontBack' : printOptions?.oneSided ? 'Front' : ''

  for (let i = 0; i < pages.length; i++) {
    const page = pages[i]

    const canvas = await html2canvas(page, {
      scale: type === 'ScoreCards' ? 2 : 4,
      useCORS: true,
    })

    const pageWidth = pdf.internal.pageSize.getWidth()
    const imgHeight = (canvas.height * pageWidth) / canvas.width
    const imgData = canvas.toDataURL('image/jpeg', 0.95)

    pdf.addImage(imgData, 'JPEG', 0, 0, pageWidth, imgHeight, '', 'FAST')

    if (i < pages.length - 1) {
      pdf.addPage()
    }
  }

  pdf.save(`${eventName}_${type}${suffix}.pdf`)
}
